'use strict';

angular.module('shiftTraderApp')
    .directive('saDaysOffUserLineItem', function (TimeService) {
      return {
        templateUrl: 'views/directives/saDaysOffUserLineItem.html',
        restrict: 'A',
        scope: {
          dayoff:'=request',
          user: '='
        },
        link: function(scope) {
          if (_.isUndefined(scope.user)) {
            scope.userObject = scope.dayoff.user;
          } else {
            scope.userObject = scope.user;
          }

          scope.dayoffMif = TimeService.minimalIntervalTimeFormat(scope.dayoff.range_twix);

        }
      };
    });
